module.exports = __webpack_public_path__ + "static/media/Unizportal-Logo.81dd2604.png";